<script setup lang="ts" generic="T extends SelectableValue">
import FormComboboxInput, {
  FormComboboxProps
} from '@/components/formComboboxInput/FormComboboxInput.vue';
import { Selectable, SelectableValue } from '@/components/selectBox/selectBox';
import { useInstitutesSearch } from '@/hooks/search/useInstitutesSearch';

const props = defineProps<Omit<FormComboboxProps<number>, 'options'>>();

defineEmits<{
  'update:modelValue': [Selectable<number> | null];
}>();

const { instituteOptions, isLoading, onQueryChange } = useInstitutesSearch(props.searchFilters);
</script>

<template>
  <FormComboboxInput
    v-bind="$props"
    :isLoading="isLoading"
    :options="instituteOptions"
    :onFilter="onQueryChange"
    :modelValue="modelValue as Selectable<number>"
    searchable
    @update:modelValue="(value) => $emit('update:modelValue', value as Selectable<number>)"
    @open="() => onQueryChange('')"
  />
</template>
